// core
import './checkVersion'
import './lib/gtm-module'
// css
import './styles/global.css'
import 'keen-slider/keen-slider.min.css'
import 'react-credit-cards/es/styles-compiled.css'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'

// head
// local components
import { EnforcerOneTab } from '@components/index'
import { isProduction } from '@config/api'
import * as Sentry from '@sentry/react'
// context
import AppProvider from '@shared/infra/hooks'
// router
import AppRoutes from '@shared/infra/router'
import { withOneTabEnforcer } from 'react-one-tab-enforcer'
import { BrowserRouter as Router } from 'react-router-dom'

import ErrorFallback from './components/errorFallback'
import { HeadScripts } from './components/HeadScripts'

function App(): JSX.Element {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, eventId }) => (
        <ErrorFallback error={error as Error} eventId={eventId} />
      )}
      onError={error => {
        const err = error as Error
        if (err.message.includes('ResizeObserver')) {
          return
        }
        Sentry.captureException(err, {
          extra: { component: 'GenericErrorBoundary' },
        })
      }}
    >
      <Router>
        <AppProvider>
          <HeadScripts />
          <AppRoutes />
        </AppProvider>
      </Router>
    </Sentry.ErrorBoundary>
  )
}

let exportApp = App

if (isProduction) {
  exportApp = withOneTabEnforcer({
    appName: document.title,
    OnlyOneTabComponent: EnforcerOneTab,
  })(App)
}

export default exportApp
